import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';

type ActionSelectionButtonProps = {
  ariaLabel: string;
  actions: {
    name: string;
    ariaLabel: string;
    onClick: () => void;
  }[];
};
const ActionSelectionButton = (props: ActionSelectionButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick: React.MouseEventHandler<HTMLElement> = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose: React.MouseEventHandler<HTMLElement> = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return props.actions && props.actions.length > 0 ? (
    <div>
      <IconButton
        aria-label={props.ariaLabel}
        aria-controls="actions-menu"
        aria-haspopup="true"
        onClick={handleClick}
        role="button"
        size="large"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {props.actions.map((action) => (
          <MenuItem
            aria-label={action.ariaLabel}
            key={action.name}
            onClick={(event) => {
              handleClose(event);
              action.onClick();
            }}
          >
            {action.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  ) : null;
};

export default ActionSelectionButton;
